
export const geoData=()=>fetch("https://get.geojs.io/v1/ip/geo.json")